import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
	return (
		<div className={styles.container}>
			<ul>
				<h3>
					<Link to="/">Ovet</Link>
				</h3>

				<div>
					<li>
						<a href="">Facebook</a>
					</li>
					<li>
						<a href="">Instagram</a>
					</li>
					<li>
						<a href="">Discord</a>
					</li>

					<li>
						{' '}
						<a href="">Mail</a>{' '}
					</li>
				</div>
			</ul>
		</div>
	);
};

export default Footer;
